// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--KQcJR","Header":"_Header--Dq36F","Confirm":"_Confirm--jT2E5"};